/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { counselingControllerCreate } from '../fn/counseling/counseling-controller-create';
import { CounselingControllerCreate$Params } from '../fn/counseling/counseling-controller-create';
import { counselingControllerFindByChildId } from '../fn/counseling/counseling-controller-find-by-child-id';
import { CounselingControllerFindByChildId$Params } from '../fn/counseling/counseling-controller-find-by-child-id';
import { counselingControllerFindById } from '../fn/counseling/counseling-controller-find-by-id';
import { CounselingControllerFindById$Params } from '../fn/counseling/counseling-controller-find-by-id';
import { counselingControllerUpdate } from '../fn/counseling/counseling-controller-update';
import { CounselingControllerUpdate$Params } from '../fn/counseling/counseling-controller-update';
import { counselingControllerValid } from '../fn/counseling/counseling-controller-valid';
import { CounselingControllerValid$Params } from '../fn/counseling/counseling-controller-valid';
import { CounselingDto } from '../models/counseling-dto';

@Injectable({ providedIn: 'root' })
export class CounselingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `counselingControllerFindByChildId()` */
  static readonly CounselingControllerFindByChildIdPath = '/api/counseling';

  /**
   * 상담지 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `counselingControllerFindByChildId()` instead.
   *
   * This method doesn't expect any request body.
   */
  counselingControllerFindByChildId$Response(params: CounselingControllerFindByChildId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CounselingDto>>> {
    return counselingControllerFindByChildId(this.http, this.rootUrl, params, context);
  }

  /**
   * 상담지 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `counselingControllerFindByChildId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  counselingControllerFindByChildId(params: CounselingControllerFindByChildId$Params, context?: HttpContext): Observable<Array<CounselingDto>> {
    return this.counselingControllerFindByChildId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CounselingDto>>): Array<CounselingDto> => r.body)
    );
  }

  /** Path part for operation `counselingControllerCreate()` */
  static readonly CounselingControllerCreatePath = '/api/counseling';

  /**
   * 상담지 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `counselingControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  counselingControllerCreate$Response(params: CounselingControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CounselingDto>> {
    return counselingControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 상담지 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `counselingControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  counselingControllerCreate(params: CounselingControllerCreate$Params, context?: HttpContext): Observable<CounselingDto> {
    return this.counselingControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CounselingDto>): CounselingDto => r.body)
    );
  }

  /** Path part for operation `counselingControllerValid()` */
  static readonly CounselingControllerValidPath = '/api/counseling/valid';

  /**
   * 상담지 유효여부.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `counselingControllerValid()` instead.
   *
   * This method doesn't expect any request body.
   */
  counselingControllerValid$Response(params: CounselingControllerValid$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return counselingControllerValid(this.http, this.rootUrl, params, context);
  }

  /**
   * 상담지 유효여부.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `counselingControllerValid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  counselingControllerValid(params: CounselingControllerValid$Params, context?: HttpContext): Observable<boolean> {
    return this.counselingControllerValid$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `counselingControllerFindById()` */
  static readonly CounselingControllerFindByIdPath = '/api/counseling/{id}';

  /**
   * 상담지 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `counselingControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  counselingControllerFindById$Response(params: CounselingControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CounselingDto>> {
    return counselingControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 상담지 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `counselingControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  counselingControllerFindById(params: CounselingControllerFindById$Params, context?: HttpContext): Observable<CounselingDto> {
    return this.counselingControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CounselingDto>): CounselingDto => r.body)
    );
  }

  /** Path part for operation `counselingControllerUpdate()` */
  static readonly CounselingControllerUpdatePath = '/api/counseling/{counselingId}';

  /**
   * 상담지 업데이트.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `counselingControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  counselingControllerUpdate$Response(params: CounselingControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CounselingDto>> {
    return counselingControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 상담지 업데이트.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `counselingControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  counselingControllerUpdate(params: CounselingControllerUpdate$Params, context?: HttpContext): Observable<CounselingDto> {
    return this.counselingControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CounselingDto>): CounselingDto => r.body)
    );
  }

}
